<template>
	<div class="d-flex flex-column equal-height">
		<!-- title -->
		<div
			class="text-body text-truncate mx-2 text-right"
			:title="attachment.title"
		>
			<span>{{ attachment.title }}</span>
		</div>
		<!-- attachments -->
		<div>
			<a href="#" @click.prevent="previewMe">
				<img
					:src="attachment.path"
					class="img-thumbnail attachment-preview"
					:alt="attachment.title"
				/>
			</a>
		</div>
		<!-- action buttons -->

		<div class="d-flex justify-content-between mx-2 mt-auto">
			<div class="flex-holder">
				<font-awesome-icon
					v-if="attachment.comment !== null"
					class="text-primary"
					:icon="['fas', 'comment']"
				/>
			</div>
			<a
				variant="outline-primary"
				class="border-0"
				:href="attachment.path"
				:download="attachment.title"
			>
				<font-awesome-icon :icon="['fas', 'download']" />
			</a>
		</div>
	</div>
</template>

<script>
	export default {
		name: "AttachmentFileShow_component",

		props: {
			attachment: {
				type: Object,
				default() {
					return {
						id: null,
						title: "title is missing",
						data: "",
						path: "",
					};
				},
			},
			uuid: {
				type: String,
				required: true,
			},
		},

		methods: {
			previewMe() {
				this.$emit("previewAttachment", this.attachment);
			},
		},
	};
</script>

<style>
	/* same height pls */
	.equal-height {
		height: 100%;
		width: 100%;
	}
	.attachment-preview {
		object-fit: cover;
	}
</style>
